// Connection auth button
// Insert in HTML <div id="authButton"></div>

import { ID3_URL } from './config';

export const authBtnId3 = (cb: (value: string) => void, cbLg: () => void) => {
  // let userId = 0;

  (() => {
    const script = document.createElement('script');
    script.async = true;
    script.src = `${ID3_URL}/js/loader.js`;
    script.onload = onLoadLoaderScript;
    document.getElementsByTagName('head')[0].appendChild(script);
  })();

  function onLoadLoaderScript() {
    //@ts-ignore
    window.AuthButton.init({ appId: 2563, typeBtn: 2 /* 1 or 2 or 3 */, handleToken, handleLogout });
  }

  function handleToken(token: string, userId: number) {
    //     console.log("-> 222", 222);
    // console.log("-> token, userId", token, userId);
    // userId = userId;
    console.log({ token, userId });
    cb(token);
  }

  function handleLogout() {
    console.log('logout');
    cbLg();
  }

  // You can call the function when the user is authorized
  // function handleActionMarketing() {
  //   console.log('-> ', 33333);
  //   if (typeof window.AuthButton !== 'undefined' && userId > 0) {
  //     window.AuthButton.saveAction([
  //       224 /*action id*/,
  //       'uaorganictraffic' /* name action*/,
  //       window.location.href /*source*/,
  //       '' /*category1*/,
  //       '' /*category2*/,
  //       '' /*actionvalue*/,
  //     ]);
  //   }
  // }
};
